export function dismissWelcomeUrl() {
  return `${window.location.pathname}/dismiss_welcome`;
}

export function animateRemoveWelcomeBanner(bannerEl) {
  const el =
    bannerEl?.closest?.("[data-welcome-banner]") ??
    document.querySelector("[data-welcome-banner]");
  if (!el) return;
  el.style.transition =
    "opacity 0.3s ease-out, transform 0.3s ease-out";
  el.style.opacity = "0";
  el.style.transform = "translateY(-10px)";
  setTimeout(() => {
    el.remove();
  }, 300);
}

export async function requestDismissWelcome(url = dismissWelcomeUrl()) {
  return fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    },
  });
}
